import IntlUtil from '../../../lib/intlutil.jsx'

export const dateFormats = {
  nl: 'dd-MM-yyyy',
  de: 'dd.MM.yyyy',
  us: 'MM/dd/yyyy',
  en: 'MM/dd/yyyy'
}

export const getErrorMessages = () => ({
  mandatory: IntlUtil.convertMessage('project.create.fieldIsRequired'),
  existingProject: IntlUtil.convertMessage(
    'project.create.projectAlreadyExists'
  )
})

export const getDateFormat = language => dateFormats[language] || dateFormats.em
export const incrementProjectNumber = (str = '') => {
  if (typeof str !== 'string') { throw Error('ProjectNumber is supposed to be a string') }
  const match = str.match(/[^0-9]/gi)
  const lastIndex = match ? str.lastIndexOf(match[match.length - 1]) : -1
  const stringToIncrement = str.substring(lastIndex + 1)
  const incrementedNumber = parseInt(stringToIncrement) + 1

  return /^\d+$/.test(stringToIncrement)
    ? str.substring(0, lastIndex + 1) +
        incrementedNumber.toString().padStart(stringToIncrement.length, '0')
    : str.concat('1')
}

export const getDefaultCopyOptionsState = ({
  isPmVisible = false,
  isPlannerAllowed = false
}) =>
  getCopyOptionsMeta({
    isPmVisible,
    isPlannerAllowed,
    canCopyActivities: false,
    canCopyAssignees: false,
    canCopyBudget: false,
    canCopyPhases: false,
    canCopyPm: false,
    canCopyTasks: false,
    canCopyTeam: false
  })

export const convertToCopyOptionsArray = (options = {}) =>
  Object.keys(options).map(optionKey => ({
    ...options[optionKey],
    key: optionKey
  }))

export const getNewCopyOptionState = (optionIdentifier, optionState) => {
  if (!optionIdentifier || !optionState) {
    throw new Error(
      'optionIdentifier and/or optionState cannot be null or undefined'
    )
  }

  const newOptionState = { ...optionState }
  const identifierNewValue = !optionState[optionIdentifier].checked

  switch (optionIdentifier) {
    case 'canCopyActivities':
      // When you switch 'activities' off, no other switches are changed
      // When you switch 'activities' on, 'phases' are switched on as well
      if (identifierNewValue) {
        newOptionState.canCopyPhases.checked = true
      }
      break
    case 'canCopyAssignees':
      // When you switch 'assignee' off, no other switches are changed
      // When you switch 'assignee' on, 'tasks' are switched on as well
      if (identifierNewValue) {
        newOptionState.canCopyTasks.checked = true
      }
      break
    case 'canCopyBudget':
    case 'canCopyTasks':
      // When you switch 'budget' off, 'phase' and 'activities' should not change
      // When you switch 'budget' on, 'phase' and 'activities' should switch on as well
      // When you switch 'tasks' off, no other switches are changed
      // When you switch 'tasks' on, 'phases' and 'activities' are switched on as well
      if (identifierNewValue) {
        newOptionState.canCopyPhases.checked = true
        newOptionState.canCopyActivities.checked = true
      }
      break
    case 'canCopyPhases':
    case 'canCopyPm':
    case 'canCopyTeam':
    default:
    // When you switch 'phase' no other switches are changed
    // When you switch 'team' no other switches are changed
  }

  newOptionState[optionIdentifier].checked = identifierNewValue
  return newOptionState
}

export const getCopyOptionsMeta = ({
  isPmVisible,
  isPlannerAllowed,
  canCopyTeam,
  canCopyBudget,
  canCopyPhases,
  canCopyActivities,
  canCopyTasks,
  canCopyAssignees,
  canCopyPm
}) => {
  const options = {
    canCopyTeam: {
      label: IntlUtil.convertMessage('project.create.copyOptionsTeam'),
      identifier: 'team',
      checked: canCopyTeam
    },
    canCopyBudget: {
      label: IntlUtil.convertMessage('project.create.copyOptionsBudget'),
      identifier: 'budget',
      checked: canCopyBudget
    },
    canCopyPhases: {
      label: IntlUtil.convertMessage('project.create.copyOptionsPhases'),
      identifier: 'phase',
      checked: canCopyPhases
    },
    canCopyActivities: {
      label: IntlUtil.convertMessage('project.create.copyOptionsActivities'),
      identifier: 'activity',
      checked: canCopyActivities
    }
  }

  isPlannerAllowed &&
    Object.assign(options, {
      canCopyTasks: {
        label: IntlUtil.convertMessage('project.create.copyOptionsTasks'),
        identifier: 'task',
        checked: canCopyTasks
      },
      canCopyAssignees: {
        label: IntlUtil.convertMessage('project.create.copyOptionsAssignees'),
        identifier: 'assignee',
        checked: canCopyAssignees
      }
    })

  isPmVisible &&
    Object.assign(options, {
      canCopyPm: {
        label: IntlUtil.convertMessage(
          'project.create.copyOptionsProjectManager'
        ),
        identifier: 'pm',
        checked: canCopyPm
      }
    })

  return options
}

export const isInArrayByKey = (arrayList = [], key, valueToCheck = '') => {
  return !!arrayList.find(
    item => item[key].toLowerCase() === valueToCheck.toLowerCase()
  )
}
